var invia = invia || {};
invia.landingPage = {};

$(document).ready(function() {
	invia.landingPage.initUaTracking();
	invia.landingPage.trackingHeaderBanner();
});

invia.landingPage.getPageName = function() {
	switch (invia.getPageAction()) {
        case 'TRIPS_LM':
        case 'TRIPS_LM_COUNTRY':
        case 'TRIPS_LM_LOCALITY':
            return 'LP Last Minute';
        case 'TRIPS_FM':
        case 'TRIPS_FM_COUNTRY':
        case 'TRIPS_FM_LOCALITY':
            return 'LP First Minute';
        case 'TRIPS_SKIING':
            return 'LP Skiing';
        case 'TRIPS_EUROWEEKENDS':
            return 'LP Euroweekends';
        case 'TRIPS_EXOTICISM':
            return 'LP Exoticism';
        case 'TRIPS_LP_SENIORS':
            return 'LP Seniors';
        default:
            return 'Invalid page action.';
	}
};

invia.landingPage.trackingHeaderBanner = function () {
	var lpHeaderBanner = $("#lp-header-banner");
	if (lpHeaderBanner.length > 0) {
		var gtmParams = lpHeaderBanner.data('gtm_params');
		if (gtmParams) {
			invia.gtm.sendEcommerce('Promo View', {
				'promoView': {
					'promotions': [
						{
							'id': gtmParams.itemId,
							'name': gtmParams.name,
							'creative': 'banner1',
							'position': 0
						}]
				}
			}, 'Hero Placement', null, true);
		}

		lpHeaderBanner.click(function () {
			var gtmParams = $(this).data('gtm_params');
			invia.gtm.sendEcommerce('Promo Click', {
				'promoClick': {
					'promotions': [
						{
							'id': gtmParams.itemId,
							'name': gtmParams.name,
							'creative': 'banner1',
							'position': 0
						}]
				}
			}, 'Hero Placement', null, true);
		});
	}
}

invia.landingPage.initUaTracking = function() {
	try {

		// maly boxiky generovany VH View_Helper_Tour_TopTours::landingPagePictures
		var boxes = $('#top-offers .lp-small-image-boxes .small-image-box');
		var page = invia.landingPage.getPageName();
		var pageId = page.split(' ').join('-').toLowerCase();

		let dataSmallImageBox = [];
		boxes.each(function(i) {
			var data = {
				name     : $(this).find('.name').text().trim(),
				id       : pageId + '-small-image-box-' + (i + 1),
				creative : 'Small Image Box',
				position : 'lp-middle-thirdwidth',
			};

			dataSmallImageBox.push(data);

			$(this).find('a').click(function() {
				try {

					invia.gtm.sendEcommerce('Internal Promo Click', {
						'promoClick': {'promotions': [data]},
					}, page + ' Country Banners', null, false);

				} catch (err) {
					invia.Console.error(err);
				}
			});
		});

		if (dataSmallImageBox.length) {
        	//@todo: pridat skiing, seniors ..... => param
			invia.gtm.sendEcommerce('Promo View', {
				'promoView': {'promotions': dataSmallImageBox},
			}, page +' Country Banners', null, true);
		}

		// velkej boxik nahore (static block)
		let topImageBox = $('#lp-sb-top');
		if (topImageBox.find('a img').length > 0) {
			var topImageBoxData = {
				name     : topImageBox.find('img').attr('alt'),
				id       : pageId + '-top-image-box',
				creative : 'Image Box',
				position : 'lp-top-fullwidth',
			};

			invia.gtm.sendEcommerce('Promo View', {
				'promoView': {'promotions': topImageBoxData},
			}, page +' Hero Banner', null, true);

			topImageBox.find('a img').first().closest('a').click(function() {
				try {

					invia.gtm.sendEcommerce('Internal Promo Click', {
						'promoClick': {'promotions': [topImageBoxData]},
					}, page +' Hero Banner', null, false);

				} catch (err) {
					invia.Console.error(err);
				}
			});
		}

		let dataTopImageBox = [];
		topImageBox.find('.category-grid-half .item .box').each(function(i) {
			var data = {
				name     : $(this).find('.title .name').text().trim(),
				id       : pageId + '-country-box-' + (i + 1),
				creative : 'Image + List of links',
				position : 'lp-middle-halfwidth',
			};

			dataTopImageBox.push(data);

			$(this).find('a').click(function() {
				try {

					invia.gtm.sendEcommerce('Internal Promo Click', {
						'promoClick': {'promotions': [data]},
					}, page + ' Country Box', null, false);

				} catch (err) {
					invia.Console.error(err);
				}
			});
		});

		if (dataTopImageBox.length) {
			invia.gtm.sendEcommerce('Promo View', {
				'promoView': {'promotions': dataTopImageBox},
			}, page + ' Subhero Banner');
		}

		let dataAttribBoxes = [];
		$('#lp-action-attrib-boxes .item').each(function(i) {
			var data = {
				name     : $(this).find('.title').text().trim(),
				id       : pageId + '-action-box-' + (i + 1),
				creative : 'Action Box',
				position : 'lp-middle-thirdwidth',
			};

			dataAttribBoxes.push(data);

			$(this).find('a').click(function() {
				try {

					invia.gtm.sendEcommerce('Internal Promo Click', {
						'promoClick': {'promotions': [data]},
					}, page + ' Action Box', null, false);

				} catch (err) {
					invia.Console.error(err);
				}
			});
		});

		if (dataAttribBoxes.length) {
			invia.gtm.sendEcommerce('Promo View', {
				'promoView': {'promotions': dataAttribBoxes},
			}, page + 'Action Box', null, true);
		}

		let otherDestinationsList = $('#other-destinations-list');
		if (otherDestinationsList.length == 1) {
			var otherDestinationsListData = {
				//name     : otherDestinationsList.find('.title').text().trim(),
				name     : 'Destinations List',
				id       : pageId + '-other-destinations-list',
				creative : 'List of links',
				position : 'lp-middle-fullwidth',
			};

			invia.gtm.sendEcommerce('Promo View', {
				'promoView': {'promotions': otherDestinationsListData},
			}, page + ' Other Destinations List', null, true);

			otherDestinationsList.find('a').click(function() {
				try {

					invia.gtm.sendEcommerce('Internal Promo Click', {
						'promoClick': {'promotions': [otherDestinationsListData]},
					}, page + ' Other Destinations List', null, false);

				} catch (err) {
					invia.Console.error(err);
				}
			});
		}

		/** DATA FOR GTM PLATFORMS **/
		let pageType = '';
		if ($('aside[role=complementary] .js-main-search-form-container').length) {
            pageType = 'search-result';
		} else if ($('div.col-side .js-main-search-form-container').length) {
            pageType = 'landing-page';
		}

		let formParams = $('.js-main-search-form-container').data('search_params');

		try {
			invia.gtmPlatform.apply({
				pageType: pageType,
				hotelID: [],
				countryName: undefined,
				localityName: undefined,
				tourCategoryID: formParams ? formParams.nl_category_id : undefined,
			});
		} catch (err) {
            invia.Console.error('GTM PLATFORMS OLD LP', err);
		}

	} catch (err) {
		invia.Console.error(err);
	}
};
